@import '~style-sheet-helpers/core.less';
@import '../authentication.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.login-form {
  color: @authentication--text-color;
}

.login-form-title {
  text-align: center;
  margin-bottom: 5px;
  font-size: 17px;
}

.git-branch {
  margin: 10px 0;
  color: @authentication--git-branch--text-color;
  font-weight: @bold;
  font-size: 16px;
  text-align: center;
}

.info-message {
  margin: 10px 0;
  font-weight: @bold;
  font-size: 16px;
  text-align: center;
}

.error-message {
  margin: 10px 0;
  background: @authentication--error--background-color;
  border: 1px solid @authentication--error--border-color;
  font-size: 13px;
  color: @authentication--error--text-color;
  border-radius: 4px;
  padding: 10px;
}

.form-inputs {
  margin-bottom: 15px;

  > div {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.remember-me-and-login {
  display: flex;
  flex-direction: row;
}

.remember-me {
  flex-grow: 1;
}
